export default "__VITE_ASSET__CGO1OunA__"